import { RequirementApprovalResponse, RequirementHistoryResponse } from "lib-klab-sdks";
import { RequirementApproval, RequirementHistory } from "../../../domain/models/requirement/requirement-workflow.model";

export function mapRequirementApproval(source: RequirementApprovalResponse): RequirementApproval {
  const { requirementApprovalId, ...fields } = source;
  return { id: requirementApprovalId, ...fields };
}

export function mapRequirementHistory(source: RequirementHistoryResponse): RequirementHistory {
  const { requirementStatusHistoryId, ...fields } = source;
  return { id: requirementStatusHistoryId, ...fields };
}
